import i18next from "i18next"
import React, { useEffect, useState } from "react"
import "register/less/registration.less"
import "register/less/terms-and-conditions.less"
import { getTermsAndConditions } from "../apicalls/api-calls"
import Field from "shared/components/forms/field"
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next'
import Modal from "shared/components/modal"

const TermsAndConditionsComponent = (props) => {
    const { t } = useTranslation()
    const [termsAndConditions, setTermsAndConditions] = useState("")
    const [acceptedTerms, setAcceptedTerms] = useState(false)
    const [showError, setShowError] = useState(false)
    const [showFullScreen, setShowFullScreen] = useState(false)

    useEffect(() => {
        setTAndC(acceptedTerms)
    }, [props.setTermsAndConditions])

    useEffect(() => {
        if (props.highlightErrors) {
            setShowError(true)
        }
    }, [props.highlightErrors])

    useEffect(() => {
        setShowFullScreen(false)
        if (props.languageId) {
            getTAndC(props.languageId)
        }
        else {
            getTAndC(1)
        }
    }, [props.languageId])

    const setTAndC = (terms) => {
        props.setTermsAndConditions((previousState) => {
            previousState.valid = validateTerms(terms)
            previousState.acceptedTerms = terms
            return previousState
        })
    }

    const validateTerms = (terms) => {
        //If terms and conditions are accepted
        return terms
    }

    const getTAndC = (languageId) => {
        const langIsoCode = languageId ? i18next.language : 'en_us'
        getTermsAndConditions(props.userId, langIsoCode, (value) => setTermsAndConditionsValue(value))
    }

    const setTermsAndConditionsValue = (value) => {
        setTermsAndConditions(value)
    }

    const onTermsAncConditionsCheckbox = () => {
        setAcceptedTerms(previousState => {
            setTAndC(!previousState)
            return !previousState
        })
    }

    return (
        <div>
            <div className="terms-container">
                        <div><p className="terms-of-service-text">{t("form.terms_and_conditions_title")}</p></div>
                        <div className="terms-of-service">
                            <div className="employee-terms-of-us">
                                <i className={"im-enlarge fullscreen"}
                                    onClick={() => setShowFullScreen(true)}
                                />
                                {parse(termsAndConditions)}
                            </div>
                        </div>
                        <div id="termsservice" className={showError && !acceptedTerms ? "tandc-error" : ""}>
                            <Field
                                type="checkbox"
                                label={t("form.terms_and_conditions")}
                                id="accepted-terms"
                                checked={acceptedTerms}
                                onChange={() => {
                                    onTermsAncConditionsCheckbox()
                                }}
                            />
                    </div>
            </div>
            <Modal
                isOpen={showFullScreen}
                submitBtnText=""
                cancelBtnText={t("form.button.close")}
                onCancel={() => {
                    setShowFullScreen(false)
                }}
                classFooterPullFight={""}
            >
                <span>
                    {parse(termsAndConditions)}
                </span>
            </Modal>
        </div>
    )
}
export default TermsAndConditionsComponent